import './ArenaRewards.css';
import {useReducer, useState} from "react";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import {useActions} from "../../../../hooks/useActions";
import ArenaRenderContainer from "./ArenaRenderContainer";
import {config} from "../../../../config";


function ArenaRewards() {

    const [, forceUpdate] = useReducer(x => x + 1, 0)

    const {user} = useTypedSelector(state => state.auth);

    let [items, setItems] = useState<any[]>([]);
    const {setUser} = useActions();
    let changeMakes = false;


    ////  season
    if (user.season_progress.currentLevel > user.season_progress.oldFreeLevel && user.season_progress.currentLevel < config.MAX_SEASON_LEVEL) {

        for (let i = (user.season_progress.oldFreeLevel + 1); i <= user.season_progress.currentLevel; i++) {
            items.push({
                type: 'free_season_progress',
                data: {
                    level: i - 1
                }
            });
        }

        user.season_progress.oldFreeLevel = user.season_progress.currentLevel;
        changeMakes = true;
    }
    if (user.season_progress.currentLevel > user.season_progress.oldPaidLevel
        && user.season_progress.currentLevel < config.MAX_SEASON_LEVEL
        && user.premium) {

        for (let i = (user.season_progress.oldPaidLevel + 1); i <= user.season_progress.currentLevel; i++) {
            items.push({
                type: 'paid_season_progress',
                data: {
                    level: i - 1
                }
            });
        }
        user.season_progress.oldPaidLevel = user.season_progress.currentLevel;
        changeMakes = true;
    }
    if ((user.season_progress.currentLevel > user.season_progress.oldFreeLevel && user.season_progress.currentLevel >= config.MAX_SEASON_LEVEL) && user.season_progress.oldFreeLevel < (config.MAX_SEASON_LEVEL + 1)) {
        items.push({
            type: 'season_progress_finish',
        });
        user.season_progress.oldFreeLevel = user.season_progress.currentLevel;
        changeMakes = true;
    }
    /// season end

    // daily
    if (user.dailys.finished.length > 0) {
        for (let i = 0; i < user.dailys.finished.length; i++) {
            items.push({
                type: 'daily_complete',
                data: user.dailys.finished[i]
            });
        }
        user.dailys.finished = [];
        changeMakes = true;
    }
    // daily end


    /////
    if (changeMakes) {
        setUser(user);
    }
    /////

    const removeItem = async () => {
        items.shift();

        setItems(items);
        await new Promise(r => setTimeout(r, 50));
        forceUpdate();
    }

    return <ArenaRenderContainer key={items.length} items={items} removeItem={removeItem}/>
}

export default ArenaRewards;